import { render, staticRenderFns } from "./CourseListing.vue?vue&type=template&id=a9fc9812&scoped=true&"
import script from "./CourseListing.vue?vue&type=script&lang=ts&"
export * from "./CourseListing.vue?vue&type=script&lang=ts&"
import style0 from "./CourseListing.vue?vue&type=style&index=0&id=a9fc9812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fc9812",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a9fc9812', component.options)
    } else {
      api.reload('a9fc9812', component.options)
    }
    module.hot.accept("./CourseListing.vue?vue&type=template&id=a9fc9812&scoped=true&", function () {
      api.rerender('a9fc9812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/classrooms/components/landing/CourseListing.vue"
export default component.exports